// importing course thumbnail for showing inside course dashboard
// import redBookWebCover from "../../../../assets/RedBookWebCover.jpg";

// importing the youtube icon for showing inside course dashboard
import profileYoutubeIcon from "../../../../../assets/profileIcons/ProfileYoutubeIcon.svg";

// importing link from react routes for routing through different pages
import { useNavigate } from "react-router-dom";

// importing the cookies library
import Cookies from "js-cookie";

export default function SubQuizeCards(props) {
  const navigate = useNavigate();
  
  function handleQuizClick() {
    if (props.isSubQuiz) {
      // Navigate to sub-quiz listing page for this quiz
      navigate(`/home/sub-quize?parentQuizId=${props.id}`);
    } else {
      // Open quiz question popup
      navigate(`/home/quiz-page?quizeId=${props.id}`);
    }
  }

  return (
    <div className="CoursesCardsWrapper" style={{ cursor: 'pointer' }}>
      <img
        src={props.thumbnail}
        alt="redBookWebCover"
        onClick={handleQuizClick}
      />
      <div className="CoursesCardsDescription1">
        <h6>{props.title}</h6>
        <h6 className="CoursesCardsContinue" onClick={handleQuizClick}>
          {props.isSubQuiz ? 'View Sub-Quizzes' : 'Start'}
        </h6>
      </div>
    </div>
  );
} 